import React from 'react';
import Geosuggest, { GeosuggestProps, Suggest } from 'react-geosuggest';
import bemBlock from '@gik/core/utils/bemBlock';
import { GoogleMapsAPIWrapperContext, LoadingSpinner } from '@gik/ui';

const blockName = 'geosuggest';

export type IGeoSuggestInput = Omit<GeosuggestProps, 'onSelectChange'> & {
  onChange?(item: string): void;
};

function GeoSuggestInput({ className, onChange, ...otherProps }: IGeoSuggestInput, ref) {
  const { isGoogleMapsAPIReady } = React.useContext(GoogleMapsAPIWrapperContext);

  const bem = bemBlock(blockName);

  function handleChange(value: Suggest) {
    if (onChange) {
      onChange(value ? value.label : '');
    }
  }

  return (
    <>
      {isGoogleMapsAPIReady ? (
        <Geosuggest
          className={bem(null, [{ 'size-base': true }], className)}
          inputClassName={bem('input')}
          suggestsClassName={bem('suggests')}
          suggestsHiddenClassName={bem('suggests', 'hidden')}
          suggestItemClassName={bem('suggest-item')}
          suggestItemActiveClassName={bem('suggest-item', 'active')}
          ref={ref}
          country="US"
          types={['(cities)']}
          getSuggestLabel={googleSuggest => googleSuggest.description.replace(', USA', '')}
          onSuggestSelect={handleChange}
          {...otherProps}
        />
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
}

export default React.forwardRef(GeoSuggestInput);
